
export class AttrUtil {

    /**
     * Get the data-ally- attribute name for the given simple name.
     *
     * @param attrName - The simple attribute name
     * @return The data-ally-prefixed name
     */
    public static getDataAllyAttrName(attrName: string): string {
        return `data-ally-${attrName}`;
    }

    /**
     * Get the data- attribute name for the given simple name.
     * The Video Studio currently using this.
     * @param attrName - The simple attribute name
     * @return The data-prefixed name
     */
    public static getDataAttrName(attrName: string): string {
        return `data-${attrName}`;
    }
}
